import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleDot, faDownLong } from '@fortawesome/free-solid-svg-icons'

export const AutoScrollButton = () =>
{
    const [speed, setSpeed] = useState(5);
    const [isScrolling, setInScrolling] = useState(false);
    const [buttonText, setButtonText] = useState("Autoscroll");


  var myInterval = setInterval(()=>StopAutoScroll(), 1000000);

  const scrollPage = (speed: number) => {
      window.scrollBy({
        top: speed,
        left: 0,
        behavior: 'smooth'
      })
  }

  const StopAutoScroll = () => {
    console.log(`stopping`);
    StartAutoScroll(0);
    clearInterval(myInterval);
    setInScrolling(false);
  }

  const StartAutoScroll = (speed: number) => {
      setInScrolling(true);
      console.log(`scrolling ${speed / 100}`)
      myInterval = setInterval(()=>scrollPage(speed / 10), 100);
  }

  const renderAutoScrollButton = () => {
    return isScrolling ? 
    <button type="button" className="btn btn1" style={{width: 200, height: 47}} onClick={() => StopAutoScroll()}><FontAwesomeIcon icon={faDownLong}/>  Stop Autoscroll</button> :
    <button type="button" className="btn btn1" style={{width: 200, height: 47}}  onClick={() => StartAutoScroll(speed)}>             
      <FontAwesomeIcon icon={faCircleDot}/> Start Autoscroll
     </button>
  }

  React.useEffect(() => {
    setButtonText(isScrolling ? "Stop Autoscroll" : "Autoscroll");
  }, [isScrolling]);

  React.useEffect(() => {
    clearInterval(myInterval);
    if (isScrolling) {
      StartAutoScroll(speed);
    }
  }, [speed]);

    return <div>
      {renderAutoScrollButton()}
      <div>
    <input type="range" id="speed" value={speed} style={{width: 200}} onChange={(e) => setSpeed(Number(e.target.value))} name="speed" min="0" max="10" />
</div>
</div>
  }

// onBtnClick("start1") // slow scroll
// onBtnClick("start2") // fast scroll
// onBtnClick("stop") // stop